import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@zurich/ui/legacy/components';
import { useAppLinkStyled } from '@zurich/ui/legacy/hooks';
import { styled } from '@zurich/ui/legacy/utils';
import { HEADER_HIGHT } from '../Layout';
export const Sidebar = ({ pathName, sidebarData }) => {
    const AppLinkStyled = useAppLinkStyled(SidebarLinkStyled);
    return (_jsx(_Fragment, { children: _jsx(SidebarWrapperStyled, { children: sidebarData.map((item, i) => (_jsxs(AppLinkStyled, { target: item.id === 'reportClaim' ? '_blank' : '', href: item.disabled ? '#' : item.link, disabled: item.disabled !== undefined ? item.disabled : false, hasPaths: item.paths.includes(pathName), onClick: item.sidebarFunction, children: [_jsx(SidebarIconStyled, { variant: item.paths.includes(pathName) ? item.iconActive : item.icon }), item.label] }, i))) }) }));
};
const SidebarWrapperStyled = styled('div')(({ theme }) => ({
    width: '100px',
    position: 'fixed', // TODO: try to use sticky if possible
    display: 'flex',
    gap: theme.spacing(0.5),
    flexDirection: 'column',
    height: `calc(100vh - ${HEADER_HIGHT})`,
    backgroundColor: 'white',
    padding: theme.spacing(2, 0),
    borderRight: `1px solid ${theme.palette.groupPrimary.lightDove}`,
    zIndex: 4,
    [theme.breakpoints.down('lg')]: {
        borderTop: `1px solid ${theme.palette.groupPrimary.lightDove}`,
        height: '62px',
        width: '100vW',
        padding: 0,
        flexDirection: 'row',
        bottom: 0,
    },
}));
const SidebarLinkStyled = styled('a', {
    shouldForwardProp: (prop) => prop !== 'hasPaths',
})(({ theme, disabled, hasPaths }) => ({
    textDecoration: 'none', // remove <a> styles
    width: '100%',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(2, 1),
    alignItems: 'center',
    cursor: 'pointer',
    color: hasPaths
        ? theme.palette.primary.main
        : disabled
            ? theme.palette.secondary.light
            : theme.palette.grey[700],
    pointerEvents: disabled ? 'none' : 'unset',
    fontSize: '0.75rem',
    position: 'relative',
    [theme.breakpoints.up('lg')]: {
        fontSize: '0.75rem',
    },
    '&:after': {
        top: 0,
        content: '""',
        background: theme.palette.primary.main,
        position: 'absolute',
        left: 0,
        width: hasPaths ? '5px' : 'unset',
        height: hasPaths ? '100%' : 'unset',
    },
    [theme.breakpoints.down('lg')]: {
        '&:after': hasPaths
            ? {
                width: '100%',
                height: '2px',
            }
            : {},
    },
    '&:hover': {
        '&:after': {
            width: '5px',
            height: '100%',
        },
        color: theme.palette.primary.main,
        [theme.breakpoints.down('lg')]: {
            '&:after': {
                width: '100%',
                height: '2px',
            },
        },
    },
}));
const SidebarIconStyled = styled(Icon)(({ theme }) => ({
    display: 'block',
    margin: '0 auto',
    fontSize: '1.15rem',
    paddingBottom: theme.spacing(0.5),
    [theme.breakpoints.up('lg')]: {
        fontSize: '1.75rem',
    },
}));
export default Sidebar;
